import { Field } from "formik";
export const InputContact = (props) => {
  return (
    <Field
      className="!tw-rounded-lg !tw-h-12 !tw-text-blue-900 !tw-px-2 !tw-border-gray-400 !tw-border"
      {...props}
    />
  );
};
